import React, { useEffect, useState } from "react";

import { FaMoneyBillWave, FaClock, FaUsers, FaCheckCircle } from "react-icons/fa";
import { Pie } from "react-chartjs-2";
import queryString from "query-string";

import List from "./Payments";
import Details from "../Payments/Details";

import { numberToCurrency } from "../../helpers/functions";
import { get } from "../../config/api";


import { Chart, registerables } from "chart.js";
Chart.register(...registerables);

const PaymentDashboard = () => {
  const limit = 10;
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState();

  const [data, setData] = useState([]);
  const [counts, setCounts] = useState({});
  const [search, setSearch] = useState("");
  const [modalData, setModalData] = useState({ show: false });

  useEffect(() => {
    handleData();
  }, []);

  useEffect(() => {
    handleTableData(1);
    setPage(1);
  }, [search]); // eslint-disable-line

  const handleData = async () => {
    try {
      const response = await get(`dashboard/counts`);
      setCounts(response.data);
    } catch (error) {
      console.log(error.message);
    }
  };

  const handleTableData = async (currentPage = page) => {
    try {
      const query = queryString.stringify({ page: currentPage, limit, search });
      const response = await get(`dashboard/payments?${query}`);

      const { data, count } = response;
      setData(data);
      setTotalCount(count);
    } catch (error) {
      console.error(error);
    }
  };

  const handlePageChange = (value) => {
    setPage(value);
    handleTableData(value);
  };

  const handleToggle = ({ show = false, id } = {}) => {
    setModalData({ show, id });
    if (!show) handleTableData();
  };

  const stats = [
    {
      title: "Total Revenue",
      value: counts.total,
      trend: counts.totalTrend,
      icon: <FaMoneyBillWave />,
      variant: "primary-accent",
    },
    {
      title: "Collections",
      value: counts.paid,
      trend: counts.paidTrend,
      icon: <FaCheckCircle />,
      variant: "success-accent",
    },
    {
      title: "Pending Dues",
      value: counts.due,
      trend: counts.dueTrend,
      icon: <FaClock />,
      variant: "warning-accent",
    },
    {
      title: "Due Payments",
      value: counts.duePayments,
      trend: counts.dueTrend,
      icon: <FaUsers />,
      variant: "danger-accent",
    },
  ];

  return (
    <>
      <h5 className="page-title">Dashboard</h5>
      <div className="row g-3 mb-4">
        {stats.map((stat, index) => (
          <div key={index} className="col-12 col-sm-6 col-xl-3">
            <div className={`card h-100 stat-card ${stat.variant}`}>
              <div className="card-body">
                <div className="d-flex align-items-center">
                  <div className="flex-shrink-0">
                    <div className="stat-icon">{React.cloneElement(stat.icon, { size: 24 })}</div>
                  </div>
                  <div className="flex-grow-1 ms-3">
                    <div className="d-flex align-items-center justify-content-between">
                      <span className="text-muted small">{stat.title}</span>
                      <span
                        className={`badge bg-${
                          stat.trend?.startsWith("-") ? "danger" : "success"
                        } bg-opacity-10 text-${
                          stat.trend?.startsWith("-") ? "danger" : "success"
                        } small`}
                      >
                        {stat.trend}
                      </span>
                    </div>
                    <h3 className="mt-1 mb-0 fw-bold">{numberToCurrency(stat.value || 0)}</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="row g-4 mb-4">
        <div className="col-12 col-xl-4">
          <div className="card h-100">
            <div className="card-header">
              <h6 className="mb-0">Payment Status Distribution</h6>
            </div>
            <div className="card-body">
              <Pie
                data={{
                  labels: ["Paid", "Pending"],
                  datasets: [
                    {
                      data: [counts.paid, counts.due],
                      backgroundColor: ["#4CAF50", "#FFC107"],
                    },
                  ],
                }}
                options={{
                  responsive: true,
                  plugins: { legend: { position: "bottom" } },
                }}
                height={300}
              />
            </div>
          </div>
        </div>
        <div className="col-12 col-xl-8">
          <List
            data={data}
            onView={handleToggle}
            page={page}
            limit={limit}
            count={totalCount}
            onPageChange={handlePageChange}
            searchValue={search}
            onSearch={(value) => setSearch(value)}
          />
        </div>
      </div>

      <Details {...modalData} isOpen={modalData.show} onToggle={() => handleToggle()} />
    </>
  );
};

export default PaymentDashboard;
